<!-- PAGE TITLE -->
<section class="bg-light-red page-title-section top-position1 bg-img cover-background left-overlay-secondary">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="text-center">
          <div class="position-relative">
            <h1>Benefits</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Benefits -->
<section class="bg-light-yellow2">
  <div class="container-fluid">
    <div class="mb-1-9 mb-md-5 text-center section-title">
      <span class="text-primary alt-font text-uppercase small letter-spacing-4 d-block mb-2 fw-bold">Benefits Galore</span>
      <h2 class="mb-0">IV Drip Therapy offers a wide range of benefits, including</h2>
    </div>
<!-- 
    <div class="row mt-n2-2">
      @for (b of benefits(); track b.ID) {
        <div class="col-lg-2 col-sm-6 mt-2-2">
          <div class="card-style-11 border-color-light-black h-100">
            <div class="icon mb-1">
              <img [src]="imgUrl(b.ImagePath)" class="w-70px mb-4"
                   [alt]="b.BenefitTitle" loading="lazy" />
            </div>
            <p>{{ b.BenefitTitle }}</p>
          </div>
        </div>
      }

      @if (!loading() && !error() && benefits().length === 0) {
        <p class="text-center">No benefits available.</p>
      }
      @if (error()) {
        <p class="text-center">Unable to load benefits right now.</p>
      }
    </div> -->

    <div class="row benefits-row">
    @for (b of benefits(); track b.ID) {
        <div class="benefit-col">
        <div class="benefit-card">
            <div class="benefit-icon">
            <img [src]="imgUrl(b.ImagePath)" [alt]="b.BenefitTitle" loading="lazy" />
            </div>
            <p class="benefit-title">{{ b.BenefitTitle }}</p>
        </div>
        </div>
    }

    @if (!loading() && !error() && benefits().length === 0) {
        <p class="text-center">No benefits available.</p>
    }
    @if (error()) {
        <p class="text-center">Unable to load benefits right now.</p>
    }
    </div>

    <div class="mt-1-9 mt-md-5 text-center">
      <p class="font-weight-600">
        The specific benefits depend on the formulation of the IV drip, as
        well as the individual’s health needs and goals.
      </p>
    </div>
  </div>
</section>